"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  transition: ", ";\n  transform: ", ";\n  visibility: ", ";\n  backface-visibility: ", ";\n\n  &:hover {\n    cursor: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Image = _styledComponents.default.img(_templateObject(), _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.top, _styledSystem.right, _styledSystem.bottom, _styledSystem.left, _styledSystem.position, _styledSystem.display, _styledSystem.zIndex, _styledSystem.maxWidth, _styledSystem.opacity, _styledSystem.maxHeight, _styledSystem.borderRadius, _styledSystem.minHeight, _styledSystem.minWidth, function (props) {
  return props.transition || 'all 0s 0s ease';
}, function (props) {
  return props.transform || 'none';
}, function (props) {
  return props.visibility || 'visible';
}, function (props) {
  return props.backfaceVisibility || 'hidden';
}, function (props) {
  return props.hover ? 'pointer' : 'auto';
});

var _default = Image;
exports.default = _default;